import React from 'react';
import { maintenance, footerLinks } from '../data/maintenance';
import { SocialLinks } from './SocialLinks';
import { isSafeHttpUrl } from '../utils/url';
export function SiteFooter() {
  const safeLinks = footerLinks.filter(link => isSafeHttpUrl(link.href));
  return <footer className="w-full max-w-xl" data-id="element-614" data-mp="3mf6kz3pypq1t">
      <div className="h-px w-full bg-border" aria-hidden="true" data-id="element-615" data-mp="3hheri59o5vvi" />

      <nav aria-label="Footer" className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 sm:mt-6 sm:gap-x-6 sm:gap-y-2" data-id="element-616" data-mp="3dgl2t9oekd1k">
        {safeLinks.map(link => <a key={link.label} href={link.href} target="_blank" rel="noopener noreferrer external" referrerPolicy="strict-origin-when-cross-origin" className="-mx-1 rounded px-1 py-1.5 text-xs text-muted-foreground underline-offset-4 transition-colors hover:text-foreground hover:underline" data-id="element-617" data-mp="33ioqiejqbc1v">
            {link.label}
          </a>)}
      </nav>

      <div className="mt-4 flex flex-col items-center gap-1 text-center" data-id="element-618" data-mp="15ptv6pwr3muu">
        <p className="text-xs text-muted-foreground" data-id="element-619" data-mp="1aqhltah2i1oj">
          Need help?{' '}
          <a href={`mailto:${maintenance.supportEmail}`} className="inline-block break-all py-1 underline underline-offset-4 hover:text-foreground" data-id="element-620" data-mp="vsp8moyztpdi">
            {maintenance.supportEmail}
          </a>
        </p>

        <div className="mt-3 sm:mt-4" data-id="element-621" data-mp="1oio2qys1ocp1">
          <SocialLinks data-id="element-622" data-mp="1ojpe74cz317a" />
        </div>

        <p className="mt-4 flex flex-col items-center text-xs text-muted-foreground sm:mt-5 sm:flex-row sm:justify-center" data-id="element-623" data-mp="1tgpjve5wu1xv">
          <span data-id="element-624" data-mp="1eqrzl9b3pwdy">{maintenance.copyright}</span>
          <span className="mx-1.5 hidden text-muted-foreground/50 sm:inline" aria-hidden="true" data-id="element-625" data-mp="1jqmt7km9h02p">
            ·
          </span>
          <address className="not-italic" data-id="element-626" data-mp="27fyyi9egwnzq">{maintenance.address}</address>
        </p>
      </div>
    </footer>;
}